/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: concat.js
 * Class: concat.js
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

module.exports = function (text1, text2) {
    return text1.concat(text2);
};
